import { IonButton, IonButtons, IonCol, IonContent, IonGrid, IonHeader, IonIcon, IonLabel, IonLoading, IonRow, IonText, IonTitle, IonToast, IonToolbar, useIonAlert } from '@ionic/react';
import { arrowBack } from 'ionicons/icons';
import React, { useEffect, useRef, useState } from 'react';
import { useHistory, useLocation } from 'react-router';
import { deveExibirCategoriaNoCupom, normalizarProdutoCupom } from '../../../../../Utils/CupomProduto';
import { empresaCarregar, requestService } from '../../../../../Utils/Services';
import "./ProjetosCupom.css";


type Props = {
  projeto: any;
  closeAction: Function;
  closeActionSimple: Function;
};

function formatarValorMonetario(valor: any) {
  if (valor === null || valor === undefined || valor === '') {
    return '0,00';
  }

  const numero = typeof valor === 'number'
    ? valor
    : parseFloat(valor.toString().replace(/\./g, '').replace(',', '.'));

  if (Number.isNaN(numero)) {
    return '0,00';
  }

  return numero.toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
}

export function obterItensFormaPagamento(formaPagamento: any, valorPagoDinheiro?: any) {
  if (!formaPagamento) {
    return [];
  }

  if (Array.isArray(formaPagamento)) {
    return formaPagamento
      .map((fp: any) => {
        const nome = fp?.pagamento || fp?.formaPagamentoNome || fp?.tipo;
        const valor = fp?.valor ?? fp?.formaPagamentoValor;

        if (!nome) {
          return null;
        }

        return {
          label: `${String(nome).toUpperCase()}:`,
          value: `R$ ${formatarValorMonetario(valor)}`
        };
      })
      .filter(Boolean);
  }

  const formaPagamentoTexto = String(formaPagamento);

  return [{
    label: formaPagamentoTexto.toLowerCase() === 'dinheiro' && valorPagoDinheiro ? 'DINHEIRO:' : 'FORMA PAGAMENTO:',
    value: formaPagamentoTexto.toLowerCase() === 'dinheiro' && valorPagoDinheiro
      ? `R$ ${formatarValorMonetario(valorPagoDinheiro)}`
      : formaPagamentoTexto.toUpperCase()
  }];
}

const ProjetosCupom: React.FC<Props> = (props: Props) => {

  const history = useHistory<any>();
  const location = useLocation<any>();
  const [showLoading, setShowLoading] = useState(false);
  const [dadosProjeto, setDadosProjeto] = useState<any>([]);
  const [exibirCategoriaNoCupom, setExibirCategoriaNoCupom] = useState(true);

  const [showToast, setShowToast] = useState(false);
  const [textToast, setTextToast] = useState("");

  const [mostartAlerta] = useIonAlert();
  const [editar, setEditar] = useState(false);

  const buscarInputRef = useRef<any>(null);
  const [alertConfirmar, setAlertConfirmar] = useState(false);

  const [showActionSheet, setShowActionSheet] = useState(false);

  const [showPopover, setShowPopover] = useState(false);
  const [popoverEvent, setPopoverEvent] = useState(null);

  const openPopover = (e: any) => {
    e.persist();
    setPopoverEvent(e);
    setShowPopover(true);
  };

  const closePopover = () => {
    setShowPopover(false);
    setPopoverEvent(null);
  };

  useEffect(() => {
    if (!props.projeto) return;

    let ativo = true;
    setDadosProjeto(props.projeto);
    setExibirCategoriaNoCupom(true);

    const empresaId = props.projeto.gsi2pk || props.projeto.gsi3pk;
    if (empresaId) {
      requestService(
        empresaCarregar.url.replace("{id}", String(empresaId).replace(/#/g, '%23')),
        { method: empresaCarregar.method },
        history,
        (response: any) => {
          if (ativo) setExibirCategoriaNoCupom(deveExibirCategoriaNoCupom(response?.Item, props.projeto));
        },
        () => {
          if (ativo) setExibirCategoriaNoCupom(true);
        },
        false
      );
    }

    return () => {
      ativo = false;
    };
  }, [props.projeto, history]);

  const itensFormaPagamento = obterItensFormaPagamento(dadosProjeto.formaPagamento, dadosProjeto.valorPagoDinheiro);
  const formaPagamentoMultipla = Array.isArray(dadosProjeto.formaPagamento) && itensFormaPagamento.length > 0;

  // function getButtons() {
  //   let resultado: any = [
  //     {
  //       text: 'Cancelar',
  //       icon: close,
  //       role: 'cancel',
  //       handler: () => {
  //         console.log('Cancel clicked');
  //       }
  //     },

  //   ];



  //   resultado.push(
  //     {
  //       text: 'Cupom TXT',
  //       icon: print,
  //       handler: async () => {
  //         setShowActionSheet(false);
  //         await gerarCupom(dadosProjeto.pk);
  //       }
  //     }
  //   );

  //   resultado.push(
  //     {
  //       text: 'Cupom PDF',
  //       icon: print,
  //       handler: async () => {
  //         setShowActionSheet(false);
  //         await gerarCupomPdf(dadosProjeto.pk);
  //       }
  //     }
  //   );

  //   resultado.push(
  //     {
  //       text: 'PDF',
  //       icon: document,
  //       handler: async () => {
  //         setShowActionSheet(false);
  //         await gerarAcompanhamento(dadosProjeto.pk);
  //       }
  //     }
  //   );

  //   if (dadosProjeto.clienteInterno == true) {

  //     if (acessos?.projetos == 'edicao') {
  //       resultado.push(
  //         {

  //           text: 'Encerrar ' + window.localStorage.getItem("servicoTipo") || "Projeto",
  //           icon: checkmarkCircle,
  //           handler: () => {
  //             setShowActionSheet(false);
  //             setAlertConfirmar(true);


  //           }
  //         }
  //       )
  //     }
  //   }
  //   else {

  //     resultado.push(
  //       {
  //         text: 'Voltar',
  //         icon: arrowBack,
  //         handler: async () => {
  //           setShowActionSheet(false);
  //           props.closeActionSimple();
  //         }
  //       }
  //     );
  //   }
  //   return resultado;
  // }

  function formataTelefone(numero: any) {
    if (numero?.length == 13) {
      let BRNumber = numero.replace("55", "").match(/(\d{2})(\d{5})(\d{4})/);
      BRNumber = "(" + BRNumber[1] + ") " + BRNumber[2] + "-" + BRNumber[3];
      return BRNumber;
    }
    else if (numero?.length == 12) {
      let BRNumber = numero.replace("55", "").match(/(\d{2})(\d{4})(\d{4})/);
      BRNumber = "(" + BRNumber[1] + ") " + BRNumber[2] + "-" + BRNumber[3];
      return BRNumber;
    }
    else { return "" };
  }

  return (

    <>
      <IonHeader className="ion-no-border">
        <IonToolbar>

          <IonButtons slot="start">
            <IonButton className="pedido-fluxo-back-button" aria-label="Voltar" fill="clear" onClick={() => props.closeActionSimple()}><IonIcon slot="icon-only" icon={arrowBack}  /></IonButton>
          </IonButtons>
          <IonTitle><span className="modal-title-text">CUPOM</span></IonTitle>

        </IonToolbar>


      </IonHeader>

      <IonContent className="recibo-modal-content" fullscreen={false}>

        <div style={{ padding: '0 10px 0 10px' }}>
          <div className="recibo-modal-paper">
            {dadosProjeto && (
              <IonGrid>
                <IonRow>
                  <IonCol>
                    <IonText style={{ marginBottom: '10px' }}>
                      <h2><b>{dadosProjeto.empresaNome}</b></h2>
                      <p>Endereço: {dadosProjeto.empresaEndereco}</p>
                      {/* <p>CNPJ: {dadosEmpresa.empresaCnpj}</p> */}
                      <p>Tel: {formataTelefone(dadosProjeto.empresaTelefone)}</p>
                      <p>Data: {dadosProjeto.dataCupom ? new Date(dadosProjeto.dataCupom).toLocaleDateString('pt-BR') : new Date().toLocaleDateString('pt-BR')} Hora: {dadosProjeto.dataCupom ? new Date(dadosProjeto.dataCupom).toLocaleTimeString('pt-BR') : new Date().toLocaleTimeString('pt-BR')}</p>
                    </IonText>
                  </IonCol>
                </IonRow>
              </IonGrid>
            )}
            {dadosProjeto && (
              <IonGrid>
                <hr style={{ borderTop: '1px solid', borderStyle: 'dashed', borderColor: 'grey', margin: '5px' }}></hr>
                <IonRow>
                  <IonCol>
                    <h2 style={{ padding: 0, margin: 0 }}>{dadosProjeto.servicoTipo || "Projeto"}: {dadosProjeto.nomeProjeto}</h2>
                  </IonCol>
                  <IonCol>
                    <IonText style={{ width: '100%', textAlign: 'right' }}>
                      <h2 style={{ padding: 0, margin: 0 }}>{dadosProjeto.clienteNome}</h2>

                      {!dadosProjeto.clienteInterno && (
                        <>
                          <p>Tel: {formataTelefone(dadosProjeto.clienteTelefone)}</p>
                          <p>Endereço: {[dadosProjeto.endereco, dadosProjeto.complemento]
                            .filter(Boolean)
                            .join(', ')}</p>
                        </>
                      )}

                    </IonText>
                  </IonCol>
                </IonRow>
                <hr style={{ borderTop: '1px solid', borderStyle: 'dashed', borderColor: 'grey', margin: '5px' }}></hr>

                <IonRow>
                  <IonCol>
                    <IonText>
                      <h2 style={{ margin: '5px 0 5px 0' }}>CUPOM NÃO FISCAL</h2>
                    </IonText>
                  </IonCol>
                </IonRow>

                {dadosProjeto.produtos && dadosProjeto.produtos.length > 0 && (
                  <>
                    <IonRow>
                      <IonCol style={{ padding: '0 0 0 5px' }} size='1'>#</IonCol>
                      <IonCol style={{ padding: '0 0 0 5px' }} size='7'>DESCRIÇÃO</IonCol>
                      <IonCol style={{ padding: '0 0 0 5px' }}>QTDE</IonCol>
                      <IonCol style={{ padding: '0 0 0 5px', textAlign: 'right', marginRight: '5px' }}>VALOR</IonCol>
                    </IonRow>
                    {dadosProjeto.produtos.map((item: any, index: any) => {
                      const itemCupom = normalizarProdutoCupom(item, exibirCategoriaNoCupom);
                      return (
                      <IonRow key={item.pk || item.sk || index}>
                        <IonCol style={{ padding: '0 0 0 5px' }} size='1'>{String(index + 1).padStart(2, '0')}</IonCol>
                        <IonCol style={{ padding: '0 0 0 5px' }} size='7'>



                          <>
                              <div>{itemCupom.descricaoPrincipal} (<IonLabel style={{ textAlign: "right", fontSize: "12px" }}>R$ {formatarValorMonetario(itemCupom.valorPrincipal)}</IonLabel>)</div>
                              {itemCupom.detalhes.map((detalhe, detalheIndex) => (
                                <div key={"desc" + detalheIndex}>
                                  {detalhe.observacao ? (
                                    <div style={{ textDecoration: "underline" }}>
                                      Observação: {detalhe.descricao}
                                    </div>
                                  ) : (
                                    <div>
                                      - {detalhe.descricao}{" "}
                                      <IonLabel style={{ textAlign: "right", fontSize: "12px" }}>
                                        R$ {formatarValorMonetario(detalhe.valor)}
                                      </IonLabel>
                                    </div>
                                  )}
                                </div>
                              ))}
                          </>



                        </IonCol>
                        <IonCol style={{ padding: '0 0 0 5px' }}>{item.quantidade.toLocaleString('pt-BR', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2
                        })}</IonCol>
                        <IonCol style={{ padding: '0 0 0 5px', textAlign: 'right', marginRight: '5px' }}>{item.subtotal.toLocaleString('pt-BR', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2
                        })}</IonCol>
                      </IonRow>
                    );})}
                    <hr style={{ borderTop: '1px solid', borderStyle: 'dashed', borderColor: 'grey', margin: '10px 5px 5px 5px' }}></hr>
                  </>
                )}

                {dadosProjeto.servicos && dadosProjeto.servicos.length > 0 && (
                  <>
                    <IonRow>
                      <IonCol style={{ padding: '0 0 0 5px' }} size='1'>#</IonCol>
                      <IonCol style={{ padding: '0 0 0 5px' }} size='7'>DESCRIÇÃO</IonCol>
                      <IonCol style={{ padding: '0 0 0 5px' }}>QTDE</IonCol>
                      <IonCol style={{ padding: '0 0 0 5px', textAlign: 'right', marginRight: '5px' }}>VALOR</IonCol>
                    </IonRow>
                    {dadosProjeto.servicos.map((item: any, index: any) => (
                      <IonRow>
                        <IonCol style={{ padding: '0 0 0 5px' }} size='1'>{String(index + 1).padStart(2, '0')}</IonCol>
                        <IonCol style={{ padding: '0 0 0 5px' }} size='7'>{item.descricao} x {item.valor.toLocaleString('pt-BR', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2
                        })}</IonCol>
                        <IonCol style={{ padding: '0 0 0 5px' }}>{item.quantidade.toLocaleString('pt-BR', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2
                        })}</IonCol>
                        <IonCol style={{ padding: '0 0 0 5px', textAlign: 'right', marginRight: '5px' }}>{item.subtotal.toLocaleString('pt-BR', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2
                        })}</IonCol>
                      </IonRow>
                    ))}
                    <hr style={{ borderTop: '1px solid', borderStyle: 'dashed', borderColor: 'grey', margin: '10px 5px 5px 5px' }}></hr>
                  </>
                )}

                {formaPagamentoMultipla && (
                  <IonRow>
                    <IonCol size="12">
                      <IonText><strong>FORMAS DE PAGAMENTO:</strong></IonText>
                    </IonCol>
                  </IonRow>
                )}
                {itensFormaPagamento.map((item: any, index: number) => (
                  <IonRow key={`pagamento-${index}`}>
                    <IonCol size="6">
                      <IonText><strong>{item.label}</strong></IonText>
                    </IonCol>
                    <IonCol size="6" style={{ textAlign: 'right' }}>
                      <IonText>{item.value}</IonText>
                    </IonCol>
                  </IonRow>
                ))}

                {dadosProjeto.extraInfo && (
                  <IonRow>
                    <IonCol size="12">
                      <IonText><strong>INFORMAÇÕES EXTRAS:</strong> {dadosProjeto.extraInfo}</IonText>
                    </IonCol>
                  </IonRow>
                )}

                {dadosProjeto.taxaEntrega && !dadosProjeto.clienteInterno && (
                  <IonRow>
                    <IonCol size="6">
                      <IonText><strong>TAXA DE ENTREGA:</strong></IonText>
                    </IonCol>
                    <IonCol size="6" style={{ textAlign: 'right' }}>
                      <IonText>
                        +R$: {dadosProjeto.taxaEntrega.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      </IonText>
                    </IonCol>
                  </IonRow>
                )}

                {dadosProjeto.desconto && (
                  <IonRow>
                    <IonCol size="6">
                      <IonText><strong>DESCONTO:</strong></IonText>
                    </IonCol>
                    <IonCol size="6" style={{ textAlign: 'right' }}>
                      <IonText>
                        -R$: {dadosProjeto.desconto.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      </IonText>
                    </IonCol>
                  </IonRow>
                )}


                {dadosProjeto.taxaServico && dadosProjeto.ehComanda && (
                  <IonRow>
                    <IonCol size="6">
                      <IonText><strong>TAXA:</strong></IonText>
                    </IonCol>
                    <IonCol size="6" style={{ textAlign: 'right' }}>
                      <IonText>
                        +R$:{dadosProjeto.taxaServico.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}%
                      </IonText>
                    </IonCol>
                  </IonRow>
                )}

                <IonRow>

                  <IonCol size='12' style={{ textAlign: 'right' }}>
                    <h2 style={{ margin: 0 }}>TOTAL R$ {dadosProjeto.valorTotal}</h2>
                  </IonCol>
                </IonRow>


              </IonGrid>
            )}



            {/* <IonActionSheet
              backdropDismiss={true}
              translucent={true}
              isOpen={showActionSheet}
              onDidDismiss={() => setShowActionSheet(false)}
              cssClass='my-custom-class'
              buttons={getButtons()}

            /> */}


            <IonToast
              isOpen={showToast}
              position="middle"
              onDidDismiss={() => setShowToast(false)}
              message={textToast}
              duration={3000}
            />

            <IonLoading
              cssClass='my-custom-class'
              isOpen={showLoading}
              onDidDismiss={() => { setShowLoading(false); }}
              spinner='circles'
            />

          </div>
        </div>
      </IonContent>

    </>


  );
};

export default ({ projeto, closeAction, closeActionSimple }: { projeto: any, closeAction: Function, closeActionSimple: Function }) => (
  <ProjetosCupom projeto={projeto} closeAction={closeAction} closeActionSimple={closeActionSimple}>
  </ProjetosCupom>
)
